module.exports = __webpack_public_path__ + "img/Convertible_Back_Side_Left.f441fa3b.svg";